import React, { useContext } from "react";
import { TranslationContext } from "../../contexts/TranslationContext";
import { ErrorFlag } from "../../services/WebApiClient";
import { hasFlag } from "../../util/flags";


export function ErrorFlagBadges({ errorFlags }: { errorFlags: ErrorFlag }) {

    const result: JSX.Element[] = [];
    if (hasFlag(errorFlags, ErrorFlag.Pullout)) {
        result.push(<PulloutWarningBadge key={ErrorFlag.Pullout} />);
    }
    if (hasFlag(errorFlags, ErrorFlag.WallMount)) {
        result.push(<WallMountWarningBadge key={ErrorFlag.WallMount} />);
    }
    if (hasFlag(errorFlags, ErrorFlag.ExceedsBounds)) {
        result.push(<ExceedsBoundsWarningBadge key={ErrorFlag.ExceedsBounds} />);
    }
    return <>{result}</>
}

export function PulloutWarningBadge() {
    const tc = useContext(TranslationContext);
    return (
        <span className="badge bg-warning text-dark"
            title={tc.translator("error badge pullout extra", "Der er udtræksvarer i dette skab der ikke kan trækkes ud for dørene.")}
            style={{marginRight: "5px"}}
        >
            {tc.translator("error badge pullout main", "Udtræk")}
        </span>
    );
}
export function WallMountWarningBadge() {
    const tc = useContext(TranslationContext);
    return (
        <span className="badge bg-warning text-dark"
            title={tc.translator("error badge WallMount extra", "Der er varer i dette skab der er monteret direkte på en væg.")}
            style={{ marginRight: "5px" }}
        >
            {tc.translator("error badge WallMount main", "Vare mod væg")}
        </span>
    );
}

export function ExceedsBoundsWarningBadge() {
    const tc = useContext(TranslationContext);
    return (
        <span className="badge bg-warning text-dark"
            title={tc.translator("error badge ExceedsBounds extra", "Der er varer i dette skab der falder udenfor skabets rammer.")}
            style={{ marginRight: "5px" }}
        >
            {tc.translator("error badge ExceedsBounds main", "Vare udenfor væg")}
        </span>
    );
}
